module.exports = __webpack_public_path__ + "img/logo-cn.8baa52cc.svg";